// extracted by mini-css-extract-plugin
export default {"emailModalStyle":"SendEmailToUser_emailModalStyle__eQEPJ","wrapper":"SendEmailToUser_wrapper__QrRAb","form":"SendEmailToUser_form__CKDyH","label":"SendEmailToUser_label__w5Fag"};